import { postCartPayment, postPayuProcessPayment, setPromoCode, setValueForCheckout } from 'actions/studentMarketPlace';
import PageDataLoader from 'components/pageDataLoader';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import DownloadAppModal from '../downloadAppModal';

const RedirectPage = ({ isPromocode, postCartPayment, postPayuProcessPayment, paymentOrderDetails, setValueForCheckout, storeCheckOutValue, singleBuyNowDetails, setPromoCode, userMarketPlaceHomeData, selectedTerm, selectedPlan
}) => {
    const [pageLoader, setPageLoader] = useState(false)
    const [showDownloadAppModal, setShowDownloadAppModal] = useState(false)

    const history = useHistory()

    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('orderId') || paymentOrderDetails?.body?.order_id;
    const status = urlParams.get('status');
    const reason = urlParams.get('reason');
    const type = urlParams.get('type') || (singleBuyNowDetails?.item && singleBuyNowDetails.item.length > 0 ? singleBuyNowDetails.item[0].resourceType : undefined);
    const id = urlParams.get('id') || (singleBuyNowDetails?.item && singleBuyNowDetails.item.length > 0 ? singleBuyNowDetails.item[0].id : undefined);
    const billingPlan = urlParams.get('billingPlan') || selectedTerm || null;
    const planName = urlParams.get('planName') || selectedPlan || null;
    // Each page stamps its own origin on the query string when it sends the user to PayU.
    // storeCheckOutValue is a global, sticky Redux flag that has repeatedly gone stale across
    // navigations (e.g. a leftover true from a prior checkout leaking into a cart payment) --
    // `from` is set fresh by whichever page is actually initiating this specific attempt, so it
    // can't leak. Only fall back to storeCheckOutValue for old links that predate this param.
    const from = urlParams.get('from') || (storeCheckOutValue ? 'checkout' : 'cart');
    const isFromCheckout = from === 'checkout';

    let checkOutParams = {
        promo: isPromocode || paymentOrderDetails?.promo,
        orderId,
        status,
        reason,
        type,
        id,
        checkout: true,
        billingPlan,
        planName,
    };

    let payuParams = isFromCheckout ? {
        promo: urlParams.get('promo') || '',
        orderId: urlParams.get('orderId'),
        type: urlParams.get('type'),
        id: urlParams.get('id'),
        checkout: true,
        billingPlan: urlParams.get('type') === 'course' ? urlParams.get('billingPlan') : null,
        planName: urlParams.get('type') === 'course' ? urlParams.get('planName') : null,
        // Batch chosen at checkout, carried through the PayU redirect; without it the student is
        // enrolled in the course but not assigned to the batch.
        standardId: urlParams.get('type') === 'course' ? (urlParams.get('standardId') || undefined) : undefined,
        isTest: true,
    } : {
        promo: urlParams.get('promo') || '',
        orderId: urlParams.get('orderId'),
        isTest: true,
    };

    const isPayuFlow = !!status;
    const processPayment = isPayuFlow ? postPayuProcessPayment : postCartPayment;
    const paramsToSend = isPayuFlow ? payuParams : checkOutParams;

    console.log("checkOutParams", checkOutParams, payuParams, singleBuyNowDetails,selectedTerm,selectedPlan);
    useEffect(() => {
        setPageLoader(true)
        if (isPayuFlow) {
            console.log("payu/process-payment payload", payuParams);
        }
        processPayment(paramsToSend, (res, error) => {
            console.log("response123", res, paramsToSend, error);
            if (res?.show?.type !== 'success') {
                if (isFromCheckout) {
                    history.replace("/user-checkout")
                    setValueForCheckout(false)
                } else {
                    history.replace("/cart")
                }
            }
            setPageLoader(false)
        },(response)=>{
            console.log('jha rahnhajnna', response);
            if(response?.show?.type == 'success'){
                setPromoCode('');
                setShowDownloadAppModal(true)
                history.replace("/thank-you")
            }
        }
        )
    }, [])
    return (
        <div>
            <PageDataLoader visible={pageLoader} />
            {showDownloadAppModal &&
            <DownloadAppModal
              showDownloadAppModal={showDownloadAppModal}
              setShowDownloadAppModal={setShowDownloadAppModal}
              userMarketPlaceHomeData={userMarketPlaceHomeData}
            />}
        </div>
    )


}
const mapStateToProps = (state) => {
    const { isPromocode, paymentOrderDetails, storeCheckOutValue, singleBuyNowDetails, userMarketPlaceHomeData, selectedTerm, selectedPlan
    } = state.studentMarketPlace
    return {
        isPromocode, paymentOrderDetails, storeCheckOutValue, singleBuyNowDetails, userMarketPlaceHomeData, selectedTerm, selectedPlan


    }
};

const mapDispatchToProps = (dispatch) => ({
    postCartPayment: (param, callback, succesCallback) => dispatch(postCartPayment(param, callback,succesCallback)),
    postPayuProcessPayment: (param, callback, succesCallback) => dispatch(postPayuProcessPayment(param, callback,succesCallback)),
    setValueForCheckout: (val) => dispatch(setValueForCheckout(val)),
    setPromoCode: (val) => dispatch(setPromoCode(val)),


});

export default connect(mapStateToProps, mapDispatchToProps)(RedirectPage)

